import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Ref, shallowRef, watch } from 'vue';
import { RouteLocationNormalizedLoaded, RouteRecordName, useRoute } from 'vue-router';
import { useLayout } from '@/composables/use-layout';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route: RouteLocationNormalizedLoaded = useRoute();
const { extractLayoutFromRoute } = useLayout();

const layout: Ref<unknown> = shallowRef(extractLayoutFromRoute(route));

watch(
  (): RouteRecordName | null | undefined => {
    return route.name;
  },
  (): void => {
    layout.value = extractLayoutFromRoute(route);
  },
);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), null, {
    default: _withCtx(() => [
      _createVNode(_component_RouterView)
    ]),
    _: 1
  }))
}
}

})